import React from "react";
import authLineLeft from "@/assets/icons/authLineLeft.svg";
import authLineRight from "@/assets/icons/authLineRight.svg";
import styles from "./AuthLine.module.scss";

export const AuthLine: React.FC = () => {
  return (
    <div className={styles.authLine}>
      <img src={authLineLeft} alt="auth line left" />
      <span>или</span>
      <img src={authLineRight} alt="auth line right" />
    </div>
  );
};

